import { useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useQueryParams } from 'use-query-params'

import { ReactComponent as Options } from '../../../../../assets/icons/options.svg'
import { ReactComponent as Refresh } from '../../../../../assets/icons/refresh.svg'
import useOnClickOutside from '../../../../../hooks/useOnClickOutside'

import NLUFiltersOptions from './NLUFiltersOptions/NLUFiltersOptions'

import { joinClassNames } from '../../../../../utils/styles'
import styles from './nlu-filters.module.scss'

export enum NLUFilterCategoryEnum {
    'ENTITIES' = 'entities',
    'INTENTS' = 'intents',
}

function NLUFilters() {
    const [, setQuery] = useQueryParams()

    const { t } = useTranslation()

    const nluFiltersRef = useRef<HTMLDivElement>(null)

    const [areFiltersOpen, setAreFiltersOpen] = useState(false)
    const [category, setCategory] = useState(NLUFilterCategoryEnum.ENTITIES)

    useOnClickOutside(nluFiltersRef, () => setAreFiltersOpen(false))

    return (
        <div className={styles.nluFilters__wrapper}>
            <button
                className={joinClassNames(
                    styles.nluFilters__btn,
                    areFiltersOpen && styles.nluFilters__btnActive
                )}
                onClick={() =>
                    setAreFiltersOpen((isFiltersOpen) => !isFiltersOpen)
                }
            >
                <Options className={styles.nluFilters__btnIcon} />
            </button>
            {areFiltersOpen && (
                <div className={styles.nluFilters} ref={nluFiltersRef}>
                    <div className={styles.nluFilters__menu}>
                        <button
                            className={joinClassNames(
                                styles.nluFilters__menuBtn,
                                category === NLUFilterCategoryEnum.ENTITIES &&
                                    styles.nluFilters__menuBtnActive
                            )}
                            onClick={() =>
                                setCategory(NLUFilterCategoryEnum.ENTITIES)
                            }
                        >
                            {t('entity')}
                        </button>
                        <button
                            className={joinClassNames(
                                styles.nluFilters__menuBtn,
                                category === NLUFilterCategoryEnum.INTENTS &&
                                    styles.nluFilters__menuBtnActive
                            )}
                            onClick={() =>
                                setCategory(NLUFilterCategoryEnum.INTENTS)
                            }
                        >
                            {t('intent')}
                        </button>
                        <button
                            onClick={() => setQuery({}, 'replace')}
                            className={styles.nluFilters__clearBtn}
                        >
                            <Refresh />
                        </button>
                    </div>
                    <NLUFiltersOptions category={category} />
                </div>
            )}
        </div>
    )
}

export default NLUFilters
